import "flag-icons/css/flag-icons.min.css";
import "v-phone-input/styles";
import { createVPhoneInput, VPhoneCountryFlagSvg, selectPhoneCountryInput } from "v-phone-input";

export function createPhoneInput(i18n) {
  return createVPhoneInput({
    ...selectPhoneCountryInput,
    countryInputComponent: /** @type {any} */ (selectPhoneCountryInput.countryInputComponent),
    countryDisplayComponent: VPhoneCountryFlagSvg,
    invalidMessage: (options) => i18n.global.t("errors.validator.phone_number", options),
  });
}
